import { IList, mapNullable } from 'annotation-tools/utils';

export const nullableToStringList = (value: string[] | undefined) =>
  mapNullable(value, e => IList<string>(e));
